import retryCallIfNeeded from '../../../restCalls';

export default function militaryBenefitsService(client) {
  const retrieveMilitaryBenefits = async payload => retryCallIfNeeded(
    client,
    () => client.post('/api/financialplan/v1/militarybenefits', payload),
  );

  return {
    retrieveMilitaryBenefits,
  };
}
